export default {
  text: 'Ta restauracja jest zawieszona. Skontaktuj się ze swoją osobą kontaktową lub napisz do nas na <a>{{supportEmail}}</a>, jeśli chcesz przywrócić dostęp',
};
